// extracted by mini-css-extract-plugin
export default {"Header":"Header_Header__dTf11","arrow":"Header_arrow__+cfIw","label":"Header_label__lG-zn"};